import { HTTP } from './_http';
import { queryString } from '../../helpers';

const addTransactionsWithFile = (form) => {
	let params = { IdentityNo: form.IdentityNo, UploadFileType: form.UploadFileType };
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/UploadEnrolmentFileAsync?${queryString(params)}`, form.FileContent)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const addTransactionsSingle = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/UploadEnrolmentFileSingle`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const updateTransactionsSingle = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/CorrectionEnrolmentFileSingle`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getTransactionFileList = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/GetUploadedSummaryAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const cancelFileList = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/SendCancellationMail`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getFileDetail = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/GetUploadedDetailResultAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getDetailsAndErrorsRows = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/DetailsAndErrorsRows`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getGetUploadedErrors = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/GetUploadedErrors`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getCollectGetDetailsAndErrors = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/CollectGetDetailsAndErrors`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { addTransactionsWithFile, addTransactionsSingle, updateTransactionsSingle, getTransactionFileList, cancelFileList, getFileDetail, getDetailsAndErrorsRows, getGetUploadedErrors, getCollectGetDetailsAndErrors }